export const isMobileDevice = () => {
  if (typeof navigator === "undefined") return false;
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || "");
};

export const detectMobileOS = () => {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return "android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  return null;
};

export const redirectToStore = (platform, androidLink, iosLink) => {
  if (platform === "android") {
    window.location.href = androidLink;
  } else if (platform === "ios") {
    window.location.href = iosLink;
  }
};

export const handleBuyNowClick = (androidLink, iosLink, setShowPlatformModal) => {
  const os = detectMobileOS();
  if (isMobileDevice() && os) {
    // Directly redirect on mobile
    redirectToStore(os, androidLink, iosLink);
  } else {
    // Show modal on desktop or unknown mobile
    setShowPlatformModal(true);
  }
};
